require('./brokerStocksView.scss');

const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const {
    Component
} = require('react');
const { connect } = require('react-redux');
const { withRouter, Prompt } = require('react-router-dom');
const classNames = require('classnames');

// @commons
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const WebappRender = require('components/conditionalRender/webappRender')
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
const BrokerMyInvestmentsProducts = require('components/broker/myInvestments/brokerMyInvestmentsProducts/brokerMyInvestmentsProducts');
const BrokerMyInvestmentsContracts = require('components/broker/myInvestments/brokerMyInvestmentsContracts/brokerMyInvestmentsContracts');
const { BrokerCustomProductLoader } = require('components/broker/brokerCustomProductLoader/brokerCustomProductLoader')
const {
    BrokerInvestmentSpecialist
} = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
const {
    BrokerTodaysMainStocks
} = require('components/broker/brokerTodaysMainStocks/brokerTodaysMainStocks');
const BrokerInformationAboutProduct = require('components/broker/brokerInformationAboutProduct/brokerInformationAboutProduct');
const { BrokerClientWarningModal } = require('components/broker/commons/brokerClientWarningModal/brokerClientWarningModal');
const {
    BrokerKnowTheseStocks
} = require('components/broker/brokerKnowTheseStocks/brokerKnowTheseStocks');
const { BrokerSearchWidget } = require('components/broker/brokerSearchWidget/brokerSearchWidget');
const BrokerRiskInformationBox = require('components/broker/brokerRiskInformationBox/brokerRiskInformationBox');
const { BrokerNoStockAccountModal } = require('components/broker/brokerSearchResults/brokerNoStockAccountModal');
const BrokerIAInvestmentModule = require('components/broker/brokerIA/brokerIAComponents/brokerIAInvestmentModule/brokerIAInvestmentModule');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @actions
const BrokerStocksByTypeActions = require('actions/brokerStocksByType');
const BrokerStocksByContractActions = require('actions/brokerWallets');
const BrokerTodaysMainStocksActions = require('actions/brokerTodaysMainStocks');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const BrokerOrdersAndMovementsActions = require('actions/brokerOrdersAndMovements');
const BrokerClientWarningModalAction = require('actions/brokerClientWarningModal');
const CollectivesCommissionsInfoAction = require('actions/collectivesCommissions');
const brokerContractState = require('actions/brokerContractState');
const BrokerSearchWidgetActions = require('actions/brokerSearchWidget');
const BrokerProductFiltersSearchActions = require('actions/brokerProductFiltersSearch');
const brokerNoStockAccountModalActions = require('actions/brokerNoStockAccountModal');

// @utilites
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @constants
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const {
    MYPROFILE_BROKER_EXPLORE_STOCKS_URL,
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_ERROR_URL,
    TYPE_STOCKS,
    COLLECTIVE_STOCK_COMMISSION,
    BROKER_RISK_TYPE_SIX,
} = require('constants/index');
const { PROC_BROKER_STOCKS_PG_NAME } = require('utilities/tagging');
const { NOT_ALLOWED_WEALTH_BROKER_IA_COUNTRIES } = require('constants/flagBasedFeatures');

class BrokerStocksView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            nextLocation: null,
            isBlockingRouteChange: false,
        };

        this.handleBuyClick = this.handleBuyClick.bind(this);
        this.handleAdvancedSearchLink = this.handleAdvancedSearchLink.bind(this)
        this.handleStocksBuyClick = this.handleStocksBuyClick.bind(this);
        this.buildStocksTabbedContent = this.buildStocksTabbedContent.bind(this);
        this.breadcrumb = [
            {
                text: formatText('stocks-investments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('stocks-stocks'),
                url: ''
            }
        ];
    }

    componentDidMount() {
        const { history, immProfile, immBrokerMyInvestments } = this.props;

        this.props.getStocksByType();
        this.props.getStocksContracts();
        this.props.getIndexes();
        this.props.checkPersonalInformationData();
        this.props.setPreoviousPage('/myprofile/broker/stocks');

        if (immProfile.get('isCollective')) {
            this.props.getCollectivesCommissionsInfo(COLLECTIVE_STOCK_COMMISSION, history);
        }
        if (immBrokerMyInvestments.get('fetchSuccess')) {
            this.setPageInteraction();
        }
        scrollToTop();
    }

    componentDidUpdate(prevProps) {
        const { immBrokerMyInvestments } = this.props;
        const immBrokerMyInvestmentsPrev = prevProps.immBrokerMyInvestments;

        if (
            immBrokerMyInvestments.get('fetchSuccess') &&
            !immBrokerMyInvestmentsPrev.get('fetchSuccess')
        ) {
            this.setPageInteraction();
        }
    }

    setPageInteraction() {
        const { immBrokerMyInvestments } = this.props;
        const productStatus = immBrokerMyInvestments.getIn(['products', 'stocks', 'total']) > 0
            ? 'active'
            : 'empty';

        this.setState({
            setProductStatus: true,
        })
        taggingEventHandled(PROC_BROKER_STOCKS_PG_NAME, 'productStatusActive', productStatus);
    }

    handleBuyClick(component) {
        taggingEventHandled(PROC_BROKER_STOCKS_PG_NAME, component === 'comercialCard' ? 'buyButtonComCard' : 'buyButton');
        this.props.resetSpecificProduct(TYPE_STOCKS.toUpperCase());
        this.props.history.push(MYPROFILE_BROKER_EXPLORE_STOCKS_URL);
    }

    handleAdvancedSearchLink() {
        taggingEventHandled(PROC_BROKER_STOCKS_PG_NAME, 'knowTheseStocksAdvSearch');
        this.props.resetSpecificProduct(TYPE_STOCKS.toUpperCase());
        this.props.history.push(MYPROFILE_BROKER_EXPLORE_STOCKS_URL);
    }

    handleStocksBuyClick(nextLink) {
        const { immbrokerClientWarningModal, showClientWarningModal, immStocksContracts, showNoStockAccountModal, history } = this.props;
        const hasNoStockContracts = immStocksContracts.isEmpty();
        const clientPersonalInfoUpdated = immbrokerClientWarningModal.get('clientPersonalInfoUpdated');
        const isFetching = immbrokerClientWarningModal.get('isFetching');
        const isFetched = immbrokerClientWarningModal.get('isFetched');
        if (isFetched && !isFetching) {
            if (!clientPersonalInfoUpdated) {
                showClientWarningModal(history);
                this.setState({
                    nextLocation: nextLink,
                    isBlockingRouteChange: true
                });
            }
            else if (hasNoStockContracts) {
                showNoStockAccountModal();
            }
            else {
                history.push(nextLink);
            }
        } else if (!isFetched && !isFetching) {
            history.push(MYPROFILE_BROKER_ERROR_URL);
        }
        window.modalInstance = this;
    }
    getTabContent() {
        const {
            immAccounts,
            immBrokerContractState,
            immBrokerMyInvestments,
            immBrokerWallets,
            immMyWalletCharts,
            getStocksByContract,
            postWalletAlias,
            onOpenTraderClick,
            setOrdersAndMovementsAccessFrom,
            setOrdersAndMovementsContract,
            getContractState,
            immBrokerLandingLoader
        } = this.props;
        const activeTab = immBrokerLandingLoader.get('activeTab');
        const isFetchingStocksByContract = immBrokerWallets.get('isFetchingProducts');
        const immStocksByContract = immBrokerWallets.get('walletList');
        const immStocksContracts = immBrokerMyInvestments.get('contracts');
        const immStocksByType = immBrokerMyInvestments.get('products');
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');

        if (activeTab == 0) {
            return (<BrokerMyInvestmentsProducts
                immStocksByType={immStocksByType}
                isFetchingStocksByType={isFetchingStocksByType}
                displayAlternativeFunds={false}
                displayStocks={true}
                displayWarrants={false}
                displayETFs={false}
                displayFunds={false}
                displayCrypto={false}
                displayPlans={false}
                displayOthers={false}
                startExpanded={true}
                alternativeValueColumnTitle={true}
                displayFooter={false}
                onOpenTraderClick={onOpenTraderClick}
                setOrdersAndMovementsAccessFrom={setOrdersAndMovementsAccessFrom}
                onHandleBuyClick={this.handleStocksBuyClick}
                resetSpecificProduct={this.props.resetSpecificProduct}
                pageName={PROC_BROKER_STOCKS_PG_NAME}
            />
            );
        }

        return (<BrokerMyInvestmentsContracts
            getStocksByContract={getStocksByContract}
            immAccounts={immAccounts}
            immStocksByContract={immStocksByContract}
            immStocksContracts={immStocksContracts}
            immStocksByType={immStocksByType}
            immMyWalletCharts={immMyWalletCharts}
            isFetchingStocksByContract={isFetchingStocksByContract}
            postWalletAlias={postWalletAlias}
            setOrdersAndMovementsContract={setOrdersAndMovementsContract}
            onOpenTraderClick={onOpenTraderClick}
            displayStocks={true}
            displayFunds={false}
            displayPlans={false}
            displayCrypto={false}
            displayFooter={false}
            onHandleBuyClick={this.handleStocksBuyClick}
            getContractState={getContractState}
            immBrokerContractState={immBrokerContractState}
            pageName={PROC_BROKER_STOCKS_PG_NAME}
        />);
    }

    buildStocksTabbedContent() {
        const {
            immBrokerMyInvestments
        } = this.props;

        const immStocksByType = immBrokerMyInvestments.get('products');
        const stocks = immStocksByType.get('stocks');
        const emptyStocks = !stocks || stocks.get('stocks').size === 0;
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');
        const title = formatText('stocks-myPositions');
        const tab = this.getTabContent();

        if (!isFetchingStocksByType && emptyStocks) {
            return undefined;
        }

        return (<ContentBox
            id="brokerStocks"
            title={title}
            customClassName={"tabbed-content-box broker-my-investments"}
        >
            {tab}
        </ContentBox>);
    }

    buildProductInfoContent() {
        const { immBrokerMyInvestments, immGlobalVariables } = this.props;
        const immStocksByType = immBrokerMyInvestments.get('products');
        const stocks = immStocksByType.get('stocks');
        const emptyStocks = !stocks || stocks.get('stocks').size === 0;

        return (
            <BrokerInformationAboutProduct
                productType={TYPE_STOCKS}
                onBuyClick={() => this.handleBuyClick('comercialCard')}
                immProfile={this.props.immProfile}
                immCollectivesCommissions={this.props.immCollectivesCommissions}
                hasButton={!emptyStocks}
                immGlobalVariables={immGlobalVariables}
                pageName={PROC_BROKER_STOCKS_PG_NAME}
            />
        );
    }

    buildCallMeBackContent() {
        return <BrokerInvestmentSpecialist />;
    }

    buildTodaysMainStocksContent() {
        return (
            <BrokerTodaysMainStocks
                onHandleBuyClick={(nextLink, productName) => {
                    taggingEventHandled(PROC_BROKER_STOCKS_PG_NAME, 'todayProtagonistsBuyButton', productName)
                    this.handleStocksBuyClick(nextLink)
                }}
                pageName={PROC_BROKER_STOCKS_PG_NAME}
            />
        );
    }

    render() {
        const { immBrokerMyInvestments, flagBasedFeatures, immProfile } = this.props;
        const productInfoContent = this.buildProductInfoContent();
        const callMeBackContent = this.buildCallMeBackContent();
        const todaysMainStocksContent = this.buildTodaysMainStocksContent();
        const stocksTabbedContent = this.buildStocksTabbedContent();
        let stocksTabbedContentObject = null;
        let stocksCTAsObject = null;
        const allowedRiskIndicator = flagBasedFeatures.get('landing_risk_indicator');
        const buySellBtnText = formatText('broker-buySellBtnText');
        const searchButtonText = formatText('brokerSearchWidget-brokerSearchWidget_searchStocks');
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');
        const colBrokerKnowTheseStocks = classNames('col-md-12', {
            'grid-view--fix-cell-separation': stocksTabbedContent,
        });
        const brokerIAFlag = flagBasedFeatures.get(NOT_ALLOWED_WEALTH_BROKER_IA_COUNTRIES);
        const brokerIAEnabled = !!brokerIAFlag && !brokerIAFlag.includes(immProfile.get('originCountry'));

        let actionLinkButton = (
            <div className="broker-general-view__action-link-btn col-sm-4">
                <OKButton
                    modifier="primary"
                    onClick={() => this.handleBuyClick('buyButton')}
                >
                    {buySellBtnText}
                </OKButton>
            </div>
        );

        const searchButton = (
            <div className="broker-general-view__action-link-btn col-sm-8">
                <OKButton
                    modifier="secondary"
                    leftIcon="icon-s-buscar"
                    block={true}
                    onClick={() => {
                        taggingEventHandled(PROC_BROKER_STOCKS_PG_NAME, 'searchButton');
                        this.props.handleShowSearchWidget()
                    }}
                >
                    {searchButtonText}
                </OKButton>
            </div>
        );

        if (!isFetchingStocksByType) {
            if (stocksTabbedContent) {
                stocksTabbedContentObject = (
                    <div className="row">
                        <div className="col-xs-12 col-md-8 broker-general-view__custom-product-loader">
                            <BrokerCustomProductLoader pageName={PROC_BROKER_STOCKS_PG_NAME} />
                        </div>
                        <div className="col-xs-12 col-md-4 broker-general-view__general-action-link-group">
                            {searchButton}
                            {actionLinkButton}
                        </div>
                        <div className="col-md-12 grid-view--fix-cell-separation">
                            {stocksTabbedContent}
                        </div>
                    </div>
                );
            } else {
                stocksCTAsObject = (
                    <div className="row">
                        <div className="col-md-12  broker-general-view__landing-action-link-group">
                            {searchButton}
                            {actionLinkButton}
                        </div>
                    </div>
                );
            }
        }
        else {
            stocksTabbedContentObject = <LoadingSection />
        }
        return (
            <React.Fragment>
                <Prompt message={() => false} when={this.state.isBlockingRouteChange} />
                <div>
                    <div className="broker-general-view__search-widget">
                        <BrokerSearchWidget product={TYPE_STOCKS} />
                    </div>
                    <BrokerClientWarningModal
                        nextLocation={this.state.nextLocation}
                        routerHookCallback={() => {
                            this.setState({ isBlockingRouteChange: false });
                        }}
                    />
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="higher-small" section="broker" customClass="col-xs-12">
                                <BrokerTruncatedBreadcrumb
                                    titleKey="stocks-title"
                                    breadcrumbConfig={this.breadcrumb}
                                />
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid grid-view--content-position-positive">
                            {allowedRiskIndicator &&
                                <BrokerRiskInformationBox riskType={BROKER_RISK_TYPE_SIX} />
                            }
                            {stocksTabbedContentObject}
                            <div className="row">
                                <div className="col-xs-12 col-md-8">
                                    <div className="row">
                                        {brokerIAEnabled && (
                                            <div className="col-md-12 grid-view--fix-cell-separation">
                                                <BrokerIAInvestmentModule compact={true} />
                                            </div>
                                        )}
                                        <div className={colBrokerKnowTheseStocks}>
                                            <BrokerKnowTheseStocks
                                                onHandleBuyClick={this.handleStocksBuyClick}
                                                onHandleAdvancedSearchClick={this.handleAdvancedSearchLink}
                                                pageName={PROC_BROKER_STOCKS_PG_NAME}
                                            />
                                        </div>
                                        <div className="col-md-12 grid-view--fix-cell-separation">
                                            {productInfoContent}
                                        </div>
                                        <div className="col-md-12 grid-view--fix-cell-separation">
                                            {todaysMainStocksContent}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    {stocksCTAsObject}
                                    <div className="row">
                                        <div className="col-md-12 grid-view--fix-cell-separation">
                                            {callMeBackContent}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 grid-view__sources">
                                    <FormattedText value="broker-infoStocksSource" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <WebappRender>
                        <div className="container-fluid grid-view__cross-selling">
                            <div className="row">
                                <CommercialAds path="broker/general" type="cross-selling" />
                            </div>
                        </div>
                    </WebappRender>
                    <BrokerNoStockAccountModal />
                </div>
            </React.Fragment>
        );
    }
}

BrokerStocksView.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    getStocksByType: PropTypes.func.isRequired,
    getStocksContracts: PropTypes.func.isRequired,
    getStocksByContract: PropTypes.func.isRequired,
    postWalletAlias: PropTypes.func.isRequired,
    getIndexes: PropTypes.func.isRequired,
    onOpenTraderClick: PropTypes.func.isRequired,
    setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired,
    immbrokerClientWarningModal: PropTypes.object,
    showClientWarningModal: PropTypes.func,
    showNoStockAccountModal: PropTypes.func,
    setOrdersAndMovementsContract: PropTypes.func.isRequired,
    immProfile: PropTypes.object,
    checkPersonalInformationData: PropTypes.func,
    getCollectivesCommissionsInfo: PropTypes.func,
    immCollectivesCommissions: PropTypes.object.isRequired,
    immMyWalletCharts: PropTypes.object.isRequired,
    getContractState: PropTypes.func.isRequired,
    setPreoviousPage: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerContractState: PropTypes.object.isRequired,
    immBrokerLandingLoader: PropTypes.object.isRequired,
    handleShowSearchWidget: PropTypes.func.isRequired,
    resetSpecificProduct: PropTypes.func,
    immGlobalVariables: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
};

module.exports.constructor = BrokerStocksView;
module.exports.BrokerStocksView = connect(
    state => ({
        immAccounts: state.accounts,
        immbrokerClientWarningModal: state.brokerClientWarningModal,
        immBrokerContractState: state.brokerContractState,
        immBrokerLandingLoader: state.brokerLandingLoader,
        immBrokerMyInvestments: state.brokerMyInvestments,
        immBrokerWallets: state.brokerWallets,
        immCollectivesCommissions: state.collectivesCommissions,
        immGlobalVariables: state.globalVariables,
        immMyWalletCharts: state.myWalletCharts,
        immProfile: state.profile,
        immStocksContracts: state.brokerStocksContract,
        flagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        checkPersonalInformationData: BrokerClientWarningModalAction.checkPersonalInformationData,
        getStocksByContract: BrokerStocksByContractActions.getStocksByWallet,
        getStocksByType: BrokerStocksByTypeActions.getStocksByType,
        getStocksContracts: BrokerStocksByContractActions.getWalletList,
        getIndexes: BrokerTodaysMainStocksActions.getIndexes,
        getCollectivesCommissionsInfo: CollectivesCommissionsInfoAction.getCollectivesCommissionsInfo,
        getContractState: brokerContractState.getContractState,
        handleShowSearchWidget: BrokerSearchWidgetActions.showSearchWidget,
        onOpenTraderClick: BrokerOpenTraderActions.openLink,
        postWalletAlias: BrokerStocksByContractActions.postWalletAlias,
        resetSpecificProduct: BrokerProductFiltersSearchActions.resetSpecificProduct,
        setOrdersAndMovementsAccessFrom: BrokerOrdersAndMovementsActions.setAccessFrom,
        setOrdersAndMovementsContract: BrokerOrdersAndMovementsActions.setContractNumber,
        setPreoviousPage: BrokerTodaysMainStocksActions.setPreoviousPage,
        showClientWarningModal: BrokerClientWarningModalAction.showClientWarningModal,
        showNoStockAccountModal: brokerNoStockAccountModalActions.showModal,
    }
)(withRouter(BrokerStocksView));
